// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { utils } from '@seedplanner/shared-utils';
import * as Sentry from '@sentry/react';
import React from 'react';
import { Outlet } from 'react-router';
import { PageError } from '../../components/common/error';
import { AppBar } from '../../components/main/appBar/AppBar';
import { PublicFooter } from '../../components/main/appFooter/PublicFooter';
import { Box } from '../base';

const LandingPageLayout = () => {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <AppBar />
      <Box component="main">
        <Sentry.ErrorBoundary
          fallback={({ error, resetError }) => <PageError error={utils.asErrorInstance(error)} retry={resetError} />}
        >
          <Outlet />
        </Sentry.ErrorBoundary>
      </Box>
      <PublicFooter />
    </Box>
  );
};

export default LandingPageLayout;
